// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBookmarkFolded = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M8.465 3A4 4 0 019 5v14.074l4.425-3.114h1.15L19 19.073V5a2 2 0 00-2-2zM6.5 1.031V1H17a4 4 0 014 4v16l-1.576.818L14 18l-5.425 3.817L7 21v-4.5H3V5a4 4 0 013.5-3.969M7 14.5V5a2 2 0 00-1-1.733A2 2 0 005 5v9.5z"
    />
  );
export default SvgIconBookmarkFolded;
